import React from 'react';
import PropTypes from 'prop-types';
import { Image } from './Image';
import {
  imgTkoverCont,
  imgTkoverContCopy,
  imgTkoverImage
} from './Styles/imgTakeover';
import { PhotographersLink } from './responsive/atoms/PhotographersLink';

export const ImageTakeover = ({ entity }) => {
  return (
    <div className="scrollable">
      <div css={imgTkoverImage}>
        <Image entity={entity} quality={100} />
        <div css={imgTkoverCont}>
          {entity.caption !== '' ? (
            <div
              css={imgTkoverContCopy}
              // eslint-disable-next-line
              dangerouslySetInnerHTML={{
                __html: entity.caption
              }}
            />
          ) : null}
          <PhotographersLink
            photographers={entity.photographers}
            color={{ text: '#555', link: '#fff' }}
          />
        </div>
      </div>
    </div>
  );
};

ImageTakeover.defaultProps = {
  entity: undefined
};

ImageTakeover.propTypes = {
  entity: PropTypes.objectOf(PropTypes.any)
};
